import useUser from '@/utils/hooks/swr/useUser';

import type { UserRoleType, UserType } from '@/types/userType';

const hasRole = (user: UserType, roleName: UserRoleType) => {
    return roleName === user?.acl_role;
};

const useUserRole = () => {
    const { user } = useUser();

    return {
        isAdmin: hasRole(user, 'admin'),
        isManager: hasRole(user, 'manager'),
        isTeamMember: hasRole(user, 'team_member'),
        currentRole: user?.acl_role
    };
};

export default useUserRole;
